// extracted by mini-css-extract-plugin
module.exports = {"cardLayout":"CardLayout_cardLayout__h9QbL","cardLayout--responsive":"CardLayout_cardLayout--responsive__27_Xb"};